import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import cn from "classnames";
import { useInterval, useBreakpoints } from "~hooks";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Shows phrases scrolling to the left, used in footer
 *
 * @param  {string[]}   phrases  							  List of phrases to display
 * @param  {string}   	textColor 			  			Text color
 * @param  {string}   	initialBackgroundColor  Initial background color before user hovers
 *
 * @return {node}
 */

const TextMarquee = ({
  phrases,
  initialBackgroundColor = `#E2FF2E`,
  textColor = `#141414`
}) => {
  // Phrases
  if (!phrases) return null;

  const DUPLICATIONS = 5;
  const duplicatedArray = [];

  for (let i = 0; i < DUPLICATIONS; i++) {
    duplicatedArray.push(phrases);
  }

  const flatDuplicatedArray = duplicatedArray.flat();

  // Colors
  const [isHovered, setIsHovered] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState(
    initialBackgroundColor
  );

  const colors = [`#E2FF2E`, `#FFCC01`, `#F58C90`, `#FF40B4`, `#B8B4FF`];

  const goToNextColor = () => {
    const currentColorIndex = colors.indexOf(backgroundColor);
    const nextColorIndex =
      currentColorIndex === colors.length - 1 ? 0 : currentColorIndex + 1;
    setBackgroundColor(colors[nextColorIndex]);
  };

  useInterval(goToNextColor, isHovered ? 700 : null);

  useEffect(() => {
    if (isHovered) {
      goToNextColor();
    }
  }, [isHovered]);

  // Mobile auto-cycle
  const { smallTablet } = useBreakpoints();

  useInterval(goToNextColor, smallTablet ? null : 2000);

  return (
    <div
      className={styles.marquee}
      style={{ backgroundColor, color: textColor }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Marquee gradient={false} speed={70}>
        {flatDuplicatedArray.map((item, i) => (
          <span className={cn(`h3`, styles.item)} key={i}>
            {item}
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default TextMarquee;
